/**
 * Created by yujn on 2018/8/17.
 */
import $api from 'teld-web-component'
export const GetSysPublicPageMsgById = (params, suc, fail) => {
        $api.ajax({
            noIdentity: true,
            url: "SMS-GetSysPublicPageMsgById",
            data: params,
            success: suc,
            failure: fail
        })
    }
    // 删除选中的反馈
export const DelFeedbackByID = (params, suc, fail) => {
        return $api.post('SMS-DelFeedbackByID', params, suc, fail)
    }
    // 根据合伙人id获取反馈列表
export const SelectFeedbackListByPartner = (params, suc, fail) => {
        return $api.post('SMS-SelectFeedbackListByPartner', params, suc, fail)
    }
    // 获取电站评论标签
export const GetStationCommentTags = (params, suc, fail) => {
        return $api.post('SMS-GetStationCommentTags', params, suc, fail)
    }
    // 获取电站评论内容
export const GetSCommentaryByWherePage = (params, suc, fail) => {
        return $api.post('SMS-GetSCommentaryByWherePage', params, suc, fail)
    }
    //
export const GetFeedbackListBySta = (params, suc, fail) => {
        return $api.post('SMS-GetFeedbackListBySta', params, suc, fail)
    }
    // 查询充电月账单
export const GetMonthlyChargeBill = (params, suc, fail) => {
    return $api.post('SMS-GetMonthlyChargeBill', params, suc, fail)
}
export const GetGroupInfoById = (params, suc, fail) => {
        return $api.post('SMS-GetGroupInfoById', params, suc, fail)
    }
    //评价官详情
export const GetEvalOfficerPortalH5 = (params, suc, fail) => {
        return $api.post('SMS-GetEvalOfficerPortalH5', params, suc, fail)
    }
    //评价值记录
export const GetEvalOXpRecords = (params, suc, fail) => {
        return $api.post('SMS-GetEvalOXpRecords', params, suc, fail)
    }
    //评价官权益详情
export const GetEvalORightDetail = (params, suc, fail) => {
    return $api.post('SMS-GetEvalORightDetail', params, suc, fail)
}

export const GetOneMessage = (params, suc, fail) => {
    return $api.post('MNCSrv-GetOneMailBoxMessage', params, suc, fail)
}

export const PreviewCommonProblems = (params, suc, fail) => {
    return $api.post('CMS-GetCommonProblemsDetail', params, suc, fail)
}




// WEBPACK FOOTER //
// ./src/service/smsapisg.js